'use strict';

import { useQuery } from '@tanstack/react-query';
import { fetchHomepageItems } from '@src/lib/api/homepageApi';

export const useHomepageItems = (params) => {
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['homepage-items', params],
        queryFn: () => fetchHomepageItems(params)
    });

    return {
        items: data?.items ?? [],
        totalRecords: data?.totalRecords ?? 0,
        isLoading,
        isError,
        refetch
    };
};
